export const EVENT_VIEWING_MODES = {
  ALLOW_ALL: 'allow_all',
  UNAUTHENTICATED_VIEWING_GUEST_CONTENT: 'unauthenticated_viewing_guest_content',
  UNAUTHENTICATED_VIEWING_MEMBER_CONTENT: 'unauthenticated_viewing_member_content',
  GUEST_VIEWING_MEMBER_CONTENT: 'guest_viewing_member_content',
};
